import { FC } from "react";
import Link from "next/link";
import ChevronRightIcon from "@heroicons/react/solid/ChevronRightIcon";
import ChevronLeftIcon from "@heroicons/react/solid/ChevronLeftIcon";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";

import { usePage } from "@hooks/use-page";

interface Props {
  targetText: string;
  hasNext?: boolean;
}

const NavigationButtons: FC<Props> = ({ targetText, hasNext = true }) => {
  const page = usePage();
  const router = useRouter();
  const { t } = useTranslation("common");

  return (
    <div className="flex flex-row justify-center items-center space-x-4">
      {page > 1 && (
        <Link
          href={{
            pathname: router.pathname,
            query: { ...router.query, page: page - 1 },
          }}
        >
          <a className="w-52 flex flex-row justify-center items-center space-x-2 bg-gray-200 rounded ring-gray-400 focus:outline-none ring-2 p-2 hover:bg-black hover:text-white group transition-color duration-200 relative pl-10">
            <ChevronLeftIcon className="absolute left-4 w-4 group-hover:w-6 group-hover:-translate-x-2 transition-all duration-200" />
            <span>{t("previous-page")}</span>
          </a>
        </Link>
      )}
      {hasNext && (
        <Link
          href={{
            pathname: router.pathname,
            query: { ...router.query, page: page + 1 },
          }}
        >
          <a className="w-52 flex flex-row justify-center items-center space-x-2 bg-gray-200 rounded ring-gray-400 focus:outline-none ring-2 p-2 hover:bg-black hover:text-white group transition-color duration-200 relative pr-10">
            <span>
              {page === 1 ? `${t("more")} ${targetText}` : t("next-page")}
            </span>
            <ChevronRightIcon className="absolute right-4 w-4 group-hover:w-6 group-hover:translate-x-2 transition-all duration-200" />
          </a>
        </Link>
      )}
    </div>
  );
};

export default NavigationButtons;
